import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { KTSVG } from '../../../_metronic/helpers';
import { toast } from 'react-toastify';
import { Card } from 'react-bootstrap';
import { PageTitle } from '../../../_metronic/layout/core';
import { getRoleById } from './core/_requests';
import { Navigate, Outlet } from 'react-router-dom'
interface PermissionAction {
  id: number;
  action: string;
  status: boolean;
}

interface PermissionGroup {
  name: string;
  actions: PermissionAction[];
}

interface RoleResponse {
  responseStatus: number;
  responseData: {
    id: number;
    name: string;
    status: number;
    permissions: PermissionGroup[];
  };
}

const ViewRole: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState<RoleResponse['responseData'] | null>(null);

  useEffect(() => {
    fetchRole();
  }, [id]);

  const fetchRole = async () => {
    try {
      setLoading(true);
      const response = await getRoleById(Number(id));
      if (response.responseStatus === 200) {
        setRole(response.responseData);
      } else {
        toast.error('Failed to fetch role details');
      }
    } catch (error) {
      toast.error('Failed to fetch role details');
    } finally {
      setLoading(false);
    }
  };

  const getActionLabel = (action: string) => {
    switch (action) {
      case 'list': return 'List';
      case 'create': return 'create';
      case 'edit': return 'Edit';
      case 'view': return 'View';
      case 'delete': return 'Delete';
      case 'export': return 'Export';
      default: return action;
    }
  };

  const getAllPossibleActions = () => {
    return ['list', 'create', 'edit', 'view', 'delete', 'export'];
  };
  if (id === '1') {
    return <Navigate to='/error/403' replace />;
  }
  if (loading) {
    return (
      <div className="d-flex justify-content-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (!role) {
    return <div>Role not found</div>;
  }

  return (
    <>
      <PageTitle>View Role</PageTitle>
      <div className="card">
        <div className="card-header border-0 pt-6">
          <div className="card-title">
            {/* <h3>Role Details</h3> */}
          </div>
          <div className="card-toolbar">
            <button
              type="button"
              className="btn btn-sm btn-light-primary"
              onClick={() => navigate('/role-management/roles')}
            >
              <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon-2" />
              Back to List
            </button>
          </div>
        </div>
        <div className="card-body pt-0">
          <div className="row mb-7">
            <div className="col-md-6">
              <label className="fw-bold text-muted">Role Name</label>
              <div className="fw-bolder fs-6 text-gray-800">{role.name}</div>
            </div>
            <div className="col-md-6">
              <label className="fw-bold text-muted">Status</label>
              <div className="fw-bolder fs-6">
                <span className={`badge badge-light-${role.status === 1 ? 'success' : 'danger'}`}>
                  {role.status === 1 ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>
          </div>
          <div className="separator separator-dashed my-5"></div>
          <div className="row mb-7">
            <div className="col-12">
              <label className="fw-bold text-muted mb-4">Permissions</label>
              <div className="row">
                {role.permissions?.map((group: PermissionGroup) => (
                  <div key={group.name} className="col-md-6 mb-4">
                    <Card className="h-100">
                      <Card.Header className="bg-light" style={{minHeight:'40px', display:"flex",alignItems:"center"}}>
                        <h5 className="mb-0">{group.name}</h5>
                      </Card.Header>
                      <Card.Body>
                        <div className="d-flex flex-column gap-3">
                          {group.actions
                            .filter(action => action.status)
                            .map((action) => (
                              <div key={action.id} className="d-flex align-items-center">
                                <div className="w-150px" >
                                  <span className="text-muted fw-semibold">{getActionLabel(action.action)}</span>
                                </div>
                                <div className="flex-grow-1">
                                  <span className="badge badge-light-success fs-7 fw-bold">
                                    Allowed
                                  </span>
                                </div>
                              </div>
                            ))}
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ViewRole; 